export const environment = {
  production: false,

  // USED FOR BANNER
  isProduction: false,

  // 180000 THREE MINUTES
  autoSaveTimout: 180000,

  showSectors: false,
  videoDocBuilderGuidanceViewer: 'https://uat-clientviewerui.peninsulagrouponline.com/main?sessionid=',
  forceOpenWordDocsInClientApp: true, // TODO REMOVE?
  uploadColumn: true,

  // MSAL CONFIGURATION
  msal: {
    clientId: '1ad2984d-3643-431b-aef8-956b7c2f9268',
    authority: 'f6aec7ed-3b3a-4826-99e1-1b3134e6b856',
    redirectUri: 'https://uat-groupdocbuilderui.peninsulagrouponline.com',
    api: 'api://b041a17c-8a96-4ca0-8d9a-0435fd03deb2'
  },

  // NEW API
  api: 'https://dev-groupdocumentbuilderapi.peninsulagrouponline.com',
};
